export const GET_ALL_SPECIALIZATIONS = "GET_ALL_SPECIALIZATIONS";
export const GET_SYMPTOMS_BY_SPECIALIZATION_ID =
  "GET_SYMPTOMS_BY_SPECIALIZATION_ID";
